import { getDeferred } from './get-deferred';
const randomBetween = (a, b) => a + Math.floor((b - a) * Math.random());
const resolveAfter = time => new Promise(res => setTimeout(res, time));
const rejectAfter = (time, reason = 'Timed out') => resolveAfter(time).then(() => Promise.reject(new Error(reason)));
export const exponentialBackoff = (action, {
  name = 'unknown',
  timeout,
  initialDelay,
  maxDelay = +Infinity,
  enableLogging = false
}) => {
  const state = {
    attempt: 0,
    aborted: false,
    timers: {
      attempt: -1,
      attemptTimeout: -1,
      timeout: -1
    },
    latestError: null,
    nextDelay: initialDelay
  };
  const log = (...args) => {
    if (enableLogging) {
      console.log(`[exponential-backoff] ${name}:`, ...args);
    }
  };
  const deferred = getDeferred();
  function doAction(attemptTimeout = initialDelay) {
    state.attempt++;
    log(`Performing action. Attempt #${state.attempt}`);
    return Promise.race([action(), rejectAfter(Math.max(0, attemptTimeout - 10), `Attempt #${state.attempt} timed out`)]).then(onSuccess).catch(backoff);
  }
  state.timers.timeout = setTimeout(() => {
    log(`Reached timeout`);
    clearTimeout(state.timers.attempt);
    clearTimeout(state.timers.attemptTimeout);
    deferred.reject(state.latestError || new Error('Action timed out.'));
  }, timeout);
  function onSuccess(result) {
    if (state.aborted) {
      return;
    }
    log(`Success at attempt #${state.attempt}`);
    clearTimeout(state.timers.timeout);
    clearTimeout(state.timers.attemptTimeout);
    deferred.resolve(result);
  }
  function backoff(e) {
    var _state$latestError;
    if (state.aborted) {
      return;
    }
    state.latestError = e;
    log(`Attempt #${state.attempt} failed. Reason: "${(_state$latestError = state.latestError) === null || _state$latestError === void 0 ? void 0 : _state$latestError.message}". Next attempt in: ${state.nextDelay}ms`);
    state.timers.attempt = setTimeout(() => {
      void doAction(state.nextDelay);
    }, state.nextDelay);
    const delay = Math.min(maxDelay, initialDelay * Math.pow(2, state.attempt));
    state.nextDelay = randomBetween(delay / 2, delay); // With jitter
  }
  function abort() {
    state.aborted = true;
    Object.values(state.timers).forEach(timer => clearTimeout(timer));
  }
  void doAction();
  return [deferred.promise, abort];
};